// @flow

export default ({ query, geojson }: { query: string, geojson: string }): string => `WITH A0 as (SELECT ST_SetSRID(ST_GeomFromGeoJSON('${geojson}'), 4326) the_geom), A1 as (${query}) SELECT  A1.* FROM A0, A1 WHERE ST_Intersects(A1.the_geom, A0.the_geom)`;
